import React, { useState } from 'react';
import {Button} from "../../elements/Button/Button";
import {TextField} from "../../elements/TextField/TextField";
import {Headings} from "../../elements/Headings/Headings";

import './FindInStore.scss';

export const EcommFindInStore = ({ title, description, buttonText, clickEvent, inventoryLevels, deliveryMethods }) => {
    const [postcode, setPostcode] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (postcode.trim() !== '') {
            setSubmitted(true);
        }
    };

    const handleChange = (event) => {
        setPostcode(event.target.value);
        if (submitted) {
            // Reset submitted state if user edits the postcode after submission
            setSubmitted(false);
        }
    };

    return (
        <div className="find-in-store" x-data="findinstore">
            <h4 className="find-in-store__title">{title}</h4>
            <p className="find-in-store__description">{description}</p>
            <form className="find-in-store__inputs" onSubmit={handleSubmit} method={'GET'}>
                <TextField id={'postcode'} placeholder={'Postcode'} value={postcode} onChange={handleChange} />
                <Button icon={true} reverse={true} text={true} label={`${buttonText}`} onClick={clickEvent}/>
            </form>

            {submitted && (
                <div className={'find-in-store__details'}>
                    <strong>
                        <Headings text={'Delivery'} type={'h4'}/>
                    </strong>
                    <div className={'find-in-store__delivery-list'}>
                        {deliveryMethods && deliveryMethods.map((method, id) => {
                            return (
                                <div key={id} className={'find-in-store__delivery-list__item'}>
                                    <span className={'item__details'}>
                                        {method.name}
                                        <small>{method.description}</small>
                                    </span>
                                    <span>${method.price}</span>
                                </div>)
                            })}
                    </div>

                    <hr className={'my-4'}/>

                    <strong>
                        <Headings text={'Click & Collect'} type={'h4'}/>
                    </strong>

                    <div className={'find-in-store-store-list'}>
                        {inventoryLevels && inventoryLevels.map((inventory_level, id) => {
                            return (
                                <div key={id} className={'find-in-store-store-list__item'}>
                                    <span className={'flex-auto'}>{inventory_level.name}</span>

                                    { inventory_level.stock_status === true && inventory_level.qty > 10  && (
                                    <span className={'instock'}>In Stock ({inventory_level.qty})</span>)}

                                    { inventory_level.stock_status === false && (
                                        <span className={'outofstock'}>Out of Stock</span>)}

                                    { inventory_level.stock_status === true && inventory_level.qty < 10 && (
                                        <span className={'limitedstock'}>Limited Stock ({inventory_level.qty})</span>)}
                                </div>
                            )
                        })}
                    </div>
                </div>)}
        </div>
    );
};
